<template>
  <div>
  <v-row class="pt-0 pb-0">
      <v-item-group
        mandatory
        v-model="tapSelect"
        @change="searchFilterData(), page=1"
      >
        <!-- <v-container> -->
          <v-row class="pl-3 pr-3 pb-4">
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }" >
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0 ma-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-format-list-bulleted</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ totalAll }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">คำร้องทั้งหมด</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FEF5E9' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#E9A016'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#E9A016' : '#FEF5E9' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-clock-time-four-outline</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #E9A016;">{{ totalPending }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">รออนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <!-- <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#EFF4FD' : 'white'"
                  :class="`pa-0 ${!active? 'border-black-v3':''}`"
                  outlined
                  style="border: 1px solid #00B0FF; box-sizing: border-box; border-radius: 4px;"
                  height="72"
                  width="167"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#00B0FF'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#00B0FF' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-timelapse</v-icon>
                  </v-col>
                  <v-col cols=8 class="mt-0 pt-1">
                    <span style="font-weight: 500; font-size: 24px; color: #00B0FF;">{{ totalPending }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">กำลังดำเนินการ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col> -->
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#ECF8EA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#58A144'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#58A144' : '#ECF8EA' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-check-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #58A144;">{{ totalApproved }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">อนุมัติแล้ว</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FBE5E4' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#D1392B'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#D1392B' : '#FBE5E4' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-close-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #D1392B;">{{ totalRejected }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">ไม่อนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#F5F5F5' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#757575'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#757575' : '#F5F5F5' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-close-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #757575;">{{ totalCancel }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">ยกเลิก</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        <!-- </v-container> -->
      </v-item-group>
  </v-row>
  <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ค้นหาหมายเลขคำร้อง</span>
      <v-autocomplete
        v-model="keywordBusinessName"
        :items="itemUserName"
        item-text="reqTokenNo"
        item-value="reqTokenNo"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาหมายเลขคำร้อง"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(), page=1"
        @click:clear="keywordBusinessName='', searchFilterData(), page=1"
      >
      <!-- <template v-slot:append>
        <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template> -->
      </v-autocomplete>
    </v-col>
    <v-col cols="6" sm="12" md="6" lg="3" class="pt-2 pb-0">
      <span class="head-search-text">ชื่อโปรเจค</span>
      <v-select
        v-model="keywordCompanyName"
        :items="itemCompanyName"
        item-text="projectName"
        item-value="projectName"
        multiple
        outlined
        placeholder="ค้นหา ชื่อโปรเจค"
        class="mt-0"
        dense
        @change="searchFilterData()"
      >
      <template v-slot:prepend-item v-if="itemCompanyName.length > 1">
          <v-list-item
            ripple
            @click="toggleCompany"
          >
            <v-list-item-action>
              <v-icon :color="keywordCompanyName.length > 0 ? 'indigo darken-4' : ''">
                {{ iconCompany }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                เลือกทั้งหมด
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-0"></v-divider>
        </template>
        <template #selection="{ item, index }">
          <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
            <span v-if="keywordCompanyName.length !== itemCompanyName.length" class="filter-chip_department" style="color: #3776E9">{{item.projectName}}</span>
            <span v-else-if="keywordCompanyName.length === itemCompanyName.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
          </v-chip>
          <v-chip  v-if="index === 1 && keywordCompanyName.length !== itemCompanyName.length" color="#EFF4FD !important" label small>
            <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordCompanyName.length - 1 }} เพิ่มเติม)</span>
          </v-chip>
        </template>
      </v-select>
    </v-col>
    <v-col cols="6" sm="12" md="6" lg="3" class="pt-2 pb-0">
      <span class="head-search-text">ชื่อผู้ร้องขอ</span>
      <v-select
        v-model="keywordSmall"
        :items="itemSmall"
        item-text="userName"
        item-value="userName"
        multiple
        outlined
        placeholder="ค้นหา ชื่อผู้ร้องขอ"
        class="mt-0"
        dense
        @change="searchFilterData()"
      >
    <template v-slot:prepend-item v-if="itemSmall.length > 1">
      <v-list-item
        ripple
        @click="toggleOrgchart"
      >
        <v-list-item-action>
          <v-icon :color="keywordSmall.length > 0 ? 'indigo darken-4' : ''">
            {{ iconOrgchart }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            เลือกทั้งหมด
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-0"></v-divider>
    </template>
    <template #selection="{ item, index }">
      <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
        <span v-if="keywordSmall.length !== itemSmall.length" class="filter-chip_department" style="color: #3776E9">{{item.userName}}</span>
        <span v-else-if="keywordSmall.length === itemSmall.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
      </v-chip>
      <v-chip  v-if="index === 1 && keywordSmall.length !== itemSmall.length" color="#EFF4FD !important" label small>
        <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordSmall.length - 1 }} เพิ่มเติม)</span>
      </v-chip>
    </template>
      </v-select>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  getSelectApproveRequestToken
} from '@/API/API'
// import axios from 'axios'
export default {
  name: 'filter-workgroup',
  props: {
    mode: String
  },
  data () {
    return {
      // tapData: ['', 'waiting', 'pending', 'approve', 'reject', 'cancel'],
      tapData: ['', 'pending', 'approve', 'reject', 'cancel'],
      tapSelect: 0,
      keywordBusinessName: '',
      keywordRequestNo: '',
      keywordPosition: [],
      keywordType: [],
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      itemUserName: [],
      itemReqNo: [],
      itemPosition: [],
      itemGroupCompanyName: [],
      itemRequestType: [],
      businessType: '',
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 50,
        page: 1
      },
      selectData: {
        companyName: [],
        requestType: [],
        status: [
          { value: 'pending', text: 'รออนุมัติ' },
          { value: 'approve', text: 'อนุมัติ' },
          { value: 'reject', text: 'ปฏิเสธอนุมัติ' },
          { value: 'cancel', text: 'ยกเลิก' }
        ],
        statusAct: [
          { value: 'pending', text: 'รอการรับทราบ' },
          { value: 'acknowledge', text: 'รับทราบ' }
        ]
      },
      menu: false,
      menu1: false,
      datesUpdateAt: [],
      datesCreateAt: [],
      menu2: false,
      createAt: '',
      updateAt: '',
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      totalCancel: 0,
      allowBtnApprove: false,
      allowBtnReject: false,
      textBtnOk: this.mode === 'approve' ? 'Approve' : 'Acknowledge',
      textBtnNO: this.mode === 'approve' ? 'Reject' : 'Unacknowledge',
      approveRole: localStorage.approveRole,
      businessModelType: '',
      keywordSmall: [],
      keywordGroupName: [],
      itemSmall: ['INET', 'OGS'],
      itemLineWorkName: [],
      itemCompanyName: ['INET', 'OGS']
    }
  },
  watch: {
    // approveRole () { return localStorage.approveRole }
    datesUpdateAt: function (val) {
      if (this.datesUpdateAt[0] !== undefined && this.datesUpdateAt[1] !== undefined) {
        this.updateAt = this.datesUpdateAt[0] + ' ' + this.datesUpdateAt[1]
        // this.searchFilterData()
      }
    },
    datesCreateAt: function (val) {
      if (this.datesCreateAt[0] !== undefined && this.datesCreateAt[1] !== undefined) {
        this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
        // this.searchFilterData()
      }
    }
  },
  computed: {
    // approveRole () { return localStorage.approveRole }
    dateRangeTextUpdate () {
      const chkDate = ''
      if (this.datesUpdateAt.length !== 0) {
        return this.datesUpdateAt.join(' ~ ')
      } else {
        return chkDate
      }
    },
    dateRangeTextCreate () {
      const chkDate = ''
      // return this.datesCreateAt.join(' ~ ')
      if (this.datesCreateAt.length !== 0) {
        return this.datesCreateAt.join(' ~ ')
      } else {
        return chkDate
      }
    },
    selectAllCompany () {
      return this.keywordCompanyName.length === this.itemCompanyName.length
    },
    selectSomeCompany () {
      return this.keywordCompanyName.length > 0 && !this.selectAllCompany
    },
    iconCompany () {
      if (this.selectAllCompany) return 'mdi-close-box'
      if (this.selectSomeCompany) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAllOrgchart () {
      return this.keywordSmall.length === this.itemSmall.length
    },
    selectSomeOrgchart () {
      return this.keywordSmall.length > 0 && !this.selectAllOrgchart
    },
    iconOrgchart () {
      if (this.selectAllOrgchart) return 'mdi-close-box'
      if (this.selectSomeOrgchart) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  async created () {
    await this.getSelectData()
    await this.searchFilterData()
  },
  beforeDestroy () {
    EventBus.$off('manageApproveExternalToken')
    EventBus.$off('updateTotalCom')
    EventBus.$off('setApproveRole')
  },
  mounted () {
    // EventBus.$on('getPosition', this.getSelectData)
    // EventBus.$on('selectPosition', this.getSelectValue)
    EventBus.$on('updateTotalCom', this.updateTotal)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  methods: {
    toggleCompany () {
      this.$nextTick(() => {
        if (this.selectAllCompany) {
          this.chkCompanyName = false
          this.keywordCompanyName = []
        } else {
          this.chkCompanyName = true
          this.keywordCompanyName = this.itemCompanyName.slice()
          for (let index = 0; index < this.keywordCompanyName.length; index++) {
            this.memoryCompanyName = []
          }
          this.searchFilterData()
        }
      })
    },
    toggleOrgchart () {
      this.$nextTick(() => {
        if (this.selectAllOrgchart) {
          this.chkOrgchart = false
          this.keywordSmall = []
        } else {
          this.chkOrgchart = true
          this.keywordSmall = this.itemSmall.slice()
          for (let index = 0; index < this.keywordSmall.length; index++) {
            this.memoryOrgchart = []
          }
          this.searchFilterData()
        }
      })
    },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      this.page = 1
      this.resetFilterData()
      await this.getSelectData()
      await this.searchFilterData()
    },
    updateTotal (value) {
      this.totalAll = value.totalAll
      this.totalPending = value.totalPending
      this.totalApproved = value.totalApproved
      this.totalRejected = value.totalRejected
      this.totalWaiting = value.totalWaiting
      this.totalCancel = value.totalCancel
    },
    async getSelectData () {
      const obj = {
        tap: 'reqTokenTap',
        userName: this.keywordSmall,
        projectName: this.keywordCompanyName,
        reqTokenNo: this.keywordBusinessName,
        status: this.setObjFilter(this.tapData[this.tapSelect]),
        role: this.approveRole
      }
      try {
        // const res = await getSelectApproveRequestCompany({ approveType: this.mode, role: this.approveRole }, this.$store.state.token)
        const res = await getSelectApproveRequestToken(obj, this.$store.state.token)
        if (res.success) {
          if (res.result) {
            this.itemCompanyName = res.result.resultDataReqToken
            this.itemSmall = res.result.resultDataReqToken
            this.itemUserName = res.result.resultDataReqToken
            this.itemReqNo = res.result.reqBusinessNoList
            this.itemBusiness = res.result.businessTypeList
          }
        }
      } catch (error) {
      } finally {
      }
    },
    resetUpdateDate () {
      this.updateAt = ''
      this.datesUpdateAt = []
      this.searchFilterData(1, 15)
    },
    resetCreateDate () {
      this.createAt = ''
      this.datesCreateAt = []
      this.searchFilterData(1, 15)
    },
    resetFilterData () {
      this.businessType = ''
      this.keywordBusinessName = ''
      this.keywordRequestNo = ''
      this.keywordPosition = []
      this.keywordType = []
      this.keywordCompanyName = []
      this.keywordGroupCompanyName = []
      this.createAt = ''
      this.updateAt = ''
      this.datesUpdateAt = []
      this.datesCreateAt = []
      this.filterData = {
        businessType: '',
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode
      }
      this.searchFilterData(1, 15)
    },
    searchFilterData () {
      this.filterData = {
        tap: 'reqTokenTap',
        userName: this.selectAllOrgchart === true ? this.memoryOrgchart : this.keywordSmall,
        projectName: this.selectAllCompany === true ? this.memoryCompanyName : this.keywordCompanyName,
        reqTokenNo: this.keywordBusinessName,
        status: this.setObjFilter(this.tapData[this.tapSelect]),
        role: this.approveRole
      }
      EventBus.$emit('manageApproveExternalToken', this.filterData)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    removeChip (item) {
      const index = this.keywordType.indexOf(item.requestTypeEng)
      if (index >= 0) this.keywordType.splice(index, 1)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
</style>
